import { IStandardConfigurationProjectSubType } from '../../interfaces/istandard-configuration-project-sub-type';
import { ProjectSubType } from '../project-sub-type';
import { StandardConfiguration } from '../standard-configuration';

export class StandardConfigurationProjectSubTypeBase {
  StandardConfigurationProjectSubTypeId: number;
  StandardConfigurationId: number | null;
  ProjectSubTypeId: number | null;
  Created: Date | null;
  CreatedBy: string | null;
  Updated: Date | null;
  UpdatedBy: string | null;

  ProjectSubType?: ProjectSubType;
  StandardConfiguration?: StandardConfiguration;

  constructor(item?: IStandardConfigurationProjectSubType) {
    if (item) {

      this.StandardConfigurationProjectSubTypeId = item.StandardConfigurationProjectSubTypeId;
      this.StandardConfigurationId = item.StandardConfigurationId;
      this.ProjectSubTypeId = item.ProjectSubTypeId;
      this.Created = item.Created ? new Date(item.Created) : null;
      this.CreatedBy = item.CreatedBy;
      this.Updated = item.Updated ? new Date(item.Updated) : null;
      this.UpdatedBy = item.UpdatedBy;

      this.ProjectSubType = new ProjectSubType(item.ProjectSubType);
      this.StandardConfiguration = new StandardConfiguration(item.StandardConfiguration);
    }
  }
}